import { render, staticRenderFns } from "./WFieldSelect2.vue?vue&type=template&id=4d6a8e6a&"
import script from "./WFieldSelect2.vue?vue&type=script&lang=ts&"
export * from "./WFieldSelect2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports